import type { Transits } from "@/lib/api/models/daily";

export function transitLine(sign: string, house: number, retrograde: boolean, conjunct: readonly string[]): string {
  const parts = [`${sign}, house ${house}`];
  if (retrograde) parts.push("retrograde");
  if (conjunct.length > 0) parts.push(`with your natal ${conjunct.join(" and ")}`);
  return `${parts.join(" · ")}.`;
}

/**
 * Sade Sati, stated rather than dramatised. The most-searched transit in the
 * tradition and the one most often sold as a catastrophe; named plainly, with
 * its phase, and with what the tradition actually asks of it.
 */
export function sadeSatiLine(t: Transits): string {
  const house = t.saturn_house_from_moon;
  if (!t.sade_sati) return `House ${house} from your Moon. Not in Sade Sati.`;
  const named = t.sade_sati_phase ? ` (${t.sade_sati_phase} phase)` : "";
  return `House ${house} from your Moon. Sade Sati is running${named} — read as a slower, more demanding stretch, not a misfortune.`;
}

export function computedAt(t: Transits): string {
  if (!t.at_utc) return "Computed from an ephemeris, not written.";
  const stamp = t.at_utc.toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  return `Computed ${stamp} from an ephemeris, not written. These positions move; open this again later and they will have.`;
}
